module.exports = __webpack_public_path__ + "static/phi-ae09df456c747467d88d2078ece84817.jpeg";